export function getUserHasAccess() {
  return {
    type: "AI_CREATOR_ACCESS",
  };
}

export function getUserHasAccessSuccess({
  hasAccess,
  whatsapp,
  unlimitedImages,
}) {
  return {
    type: "AI_CREATOR_ACCESS_SUCCESS",
    payload: { hasAccess, whatsapp, unlimitedImages },
  };
}

export function getUserHasAccessFailure(error) {
  return {
    type: "AI_CREATOR_ACCESS_FAILURE",
    payload: error,
  };
}

export function getGeneratedImages() {
  return {
    type: "AI_CREATOR_GET_GENERATED_IMAGES",
  };
}

export function getGeneratedImagesSuccess({
  generatedImages,
  remainingAttempts,
}) {
  return {
    type: "AI_CREATOR_GET_GENERATED_IMAGES_SUCCESS",
    payload: { generatedImages, remainingAttempts },
  };
}

export function getGeneratedImagesFailure(error) {
  return {
    type: "AI_CREATOR_GET_GENERATED_IMAGES_FAILURE",
    payload: error,
  };
}

export function updateRemaningAttempts({ number }) {
  return {
    type: "UPDATE_REMAINING_ATTEMPTS",
    payload: { number },
  };
}

export function getMediaKitImages() {
  return {
    type: "GET_MEDIA_KIT",
  };
}

export function getMediaKitImagesSuccess({ dataUrls }) {
  return {
    type: "GET_MEDIA_KIT_SUCCESS",
    payload: { dataUrls },
  };
}

export function getMediaKitImagesFailure({ error }) {
  return {
    type: "GET_MEDIA_KIT_FAILURE",
    payload: { error },
  };
}

export function setMediaKit({ dataUrls }) {
  return {
    type: "FINAL_MEDIA_KIT",
    payload: { dataUrls },
  };
}

export function ResetCreatorAI() {
  return {
    type: "RESET_CREATOR_AI",
  };
}

export function ResetCreatorAISuccess() {
  return {
    type: "RESET_CREATOR_AI_SUCCESS",
  };
}

// ADMIN

export function getMediaKitReportAdmin({
  year,
  eventId,
  search,
  page,
  per_page,
  sortBy,
  order,
  status,
}) {
  return {
    type: "GET_MEDIA_KIT_REPORT",
    payload: { year, eventId, search, page, per_page, sortBy, order, status },
  };
}

export function getMediaKitReportAdminSuccess({ data, pageInfo }) {
  return {
    type: "GET_MEDIA_KIT_REPORT_SUCCESS",
    payload: { data, pageInfo },
  };
}

export function getMediaKitReportAdminFailure({ error }) {
  return {
    type: "GET_MEDIA_KIT_REPORT_FAILURE",
    payload: { error },
  };
}

export function updateMediaKitStatus({
  opportunityId,
  created,
  origin,
}) {
  return {
    type: "UPDATE_MEDIA_KIT_STATUS",
    payload: { opportunityId, created, origin },
  };
}